var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-result',{attrs:{"status":"error","title":"Prohibition of access"},scopedSlots:_vm._u([{key:"extra",fn:function(){return undefined},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }